import { useState, useEffect } from 'react';

export function useMediaQuery(query: string) {
  // Read the query straight away, so the first render already matches it
  // (phones would otherwise flash the desktop layout).
  const [matches, setMatches] = useState(
    () => window.matchMedia?.(query).matches ?? false,
  );

  useEffect(() => {
    const media = window.matchMedia(query);
    setMatches(media.matches);
    const listener = () => setMatches(media.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, [query]);

  return matches;
}
